import React from 'react';
import { problemData } from '../data/mock';
import useScrollAnimation from '../hooks/useScrollAnimation';
import InnerArchitectureVisual from './graphics/InnerArchitectureVisual';
import FloatingParticles from './graphics/FloatingParticles';

export const ProblemSection = () => {
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });
  const [visualRef, visualVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="about" className="bg-[#0f1a2a] py-24 lg:py-32 relative overflow-hidden">
      {/* Background Effects */}
      <div className="noise-overlay" />
      <FloatingParticles count={25} />
      
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#5a7fa8] opacity-[0.03] blur-[120px] rounded-full" />
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10">
        {/* Section Title - Centered */}
        <div
          ref={titleRef}
          className={`text-center mb-16 lg:mb-20 animate-on-scroll ${titleVisible ? 'is-visible' : ''}`}
        >
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-[#f5f5f0] leading-tight">
            {problemData.sectionTitle}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Left Column - Visual */}
          <div
            ref={visualRef}
            className={`scale-in ${visualVisible ? 'is-visible' : ''}`}
          >
            <InnerArchitectureVisual isVisible={visualVisible} />
          </div>

          {/* Right Column - Content */}
          <div 
            ref={contentRef}
            className={`stagger-children ${contentVisible ? 'is-visible' : ''}`}
          >
            {/* Observations */}
            <div className="space-y-6 mb-12">
              {problemData.observations.map((observation, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 text-[#b8c5d4] group"
                >
                  <span className="w-2 h-2 rounded-full bg-[#5a7fa8] mt-2 flex-shrink-0 group-hover:bg-[#c9a87c] transition-colors duration-300" />
                  <p className="text-base leading-relaxed group-hover:text-[#f5f5f0] transition-colors duration-300">{observation}</p>
                </div>
              ))}
            </div>

            {/* Key Insight */}
            <div className="pt-8 border-t border-[#2a3a4d] relative">
              {/* Glow accent */}
              <div className="absolute top-0 left-0 w-20 h-px bg-gradient-to-r from-[#c9a87c] to-transparent" />
              <p className="font-serif text-xl md:text-2xl text-[#f5f5f0] leading-relaxed">
                {problemData.keyInsight}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
